
































import { Component, Watch } from 'vue-property-decorator';
import { AppMediumsModule } from '@/store/Settings/AppMediumsModule';
import Alert from '@/components/Shared/Alert.vue';
import PageNames from '@/router/PageNames';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import AppMediumState from '@/components/Settings/AppMediums/AppMediumState.vue';
import AppMediumCreate from '@/components/Settings/AppMediums/AppMediumCreate.vue';
import AppMedium from '@/models/Settings/AppMediums/AppMedium';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'AppMediums', components: { Alert, AppMediumState, AppMediumCreate }, metaInfo: { title: 'App Mediums' } })
export default class extends SaascadaVue {

    PermissionUtils = PermissionUtils;
    search = '';
    // NOTE: The 'value' field here is needed for local searching on the table, until server side searching is added
    headers = [
        { text: this.$t('pageText.appMediums.fields.name'), value: 'name', sortable: false, width: '35%' },
        { text: this.$t('pageText.appMediums.fields.type'), value: 'type', sortable: false, width: '30%' },
        { text: this.$t('pageText.appMediums.fields.updatedAt'), value: 'type', sortable: false, width: '20%' },
        { text: this.$t('pageText.appMediums.fields.state'), sortable: false, width: '15%' }
    ];
    appMediumsPage = 1;

    async created() {
        // Check for page number in URL parameters
        const page = this.$route.query.page;
        if (page) {
            this.appMediumsPage = +page;
        }
    }

    async beforeMount() {
        await AppMediumsModule.getAppMediums(this.appMediumsPage);
    }

    get appMediums() {
        return AppMediumsModule.appMediums;
    }

    get totalAppMediumsPages() {
        return AppMediumsModule.totalAppMediumsPages;
    }

    get loading() {
        return AppMediumsModule.loading;
    }

    get pageSize() {
        return AppMediumsModule.pageSize;
    }

    @Watch('appMediumsPage')
    async onAppMediumsPageChanged() {
        // Update current page route with page number
        this.$router.push({ name: this.$route.name, query: { page: `${this.appMediumsPage}` } });
        // Get new app mediums
        await AppMediumsModule.getAppMediums(this.appMediumsPage);
    }

    async navigateToAppMedium(appMedium: AppMedium) {
        this.$router.push({ name: PageNames.AppMedium, params: { id: appMedium.id }, query: { tab: "0" } });
    }

}
